import styled from '@emotion/styled'
import { IconButton } from 'components/core/IconButton'
import Row from 'components/core/Row'
import Typography from 'components/core/Typography'
import { DESIGN_TOKENS } from 'constants/color.constants'
import { SPACING } from 'constants/spacing.constants'
import { FileIcon, X } from 'lucide-react'
import { pxToRem } from 'utils/rem.utils'

const StyledFileAttachmentPill = styled(Row)`
    max-width: ${pxToRem(200)};
    background: ${DESIGN_TOKENS.background.secondary};
    border-radius: ${DESIGN_TOKENS.borderRadius.md};
    .fileAttachmentPill__fileName {
        min-width: 0;
    }
    .fileAttachmentPill__fileIcon {
        min-width: ${SPACING.p2};
    }
`

export const FileAttachmentPill = ({
    file,
    onRemove,
}: {
    file: File
    onRemove: () => void
}) => {
    return (
        <StyledFileAttachmentPill alignItems="center" gap="sm" pl="p1" pr="sm">
            <div className="fileAttachmentPill__fileIcon">
                <FileIcon
                    size={SPACING.p2}
                    color={DESIGN_TOKENS.text.foreground}
                />
            </div>
            <div className="fileAttachmentPill__fileName" title={file.name}>
                <Typography
                    shouldTruncate
                    noWrap
                    color="primary"
                    variant="body2"
                >
                    {file.name}
                </Typography>
            </div>
            <IconButton size="sm" onClick={onRemove}>
                <X size={SPACING.p2} />
            </IconButton>
        </StyledFileAttachmentPill>
    )
}
